.flag {
  align-self: stretch;
  display: flex;
  align-items: center;
}
